import React from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Box, useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "none",
		marginLeft: "auto",
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(1),
		alignItems: "center",
		"& > *": {
			margin: 0, // Remove margin padrão para usar gap
		},
	},
	mobileWrapper: {
		flexDirection: "column",
		alignItems: "stretch",
		width: "100%",
		marginLeft: 0,
		marginTop: theme.spacing(1),
		"& > *": {
			width: "100%",
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box className={`${classes.MainHeaderButtonsWrapper} ${isMobile ? classes.mobileWrapper : ''}`}>
			{children}
		</Box>
	);
};

export default MainHeaderButtonsWrapper;
